import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "changer" ]

  connect() {
    console.log("STIMULUS IS CONNECTED");
    this.interval = setInterval(this.updateChanger.bind(this), 5000);
  }

  disconnect() {
    console.log("STIMULUS IS DISCONNECTED");
    clearInterval(this.interval);
  }

  isThemeHydrated() {
    return this.element.classList.contains('hydrated');
  }

  sayHello() {
    alert("HELLO");
  }

  updateChanger() {
    this.changerTarget.innerHTML = this.changerTarget.innerHTML + "-";
  }

}

